import { type ComponentType, forwardRef, type InputHTMLAttributes, type RefAttributes } from "react";
import GoogleAutocompleteModule, { type ReactGoogleAutocompleteInputProps } from "react-google-autocomplete";
import { unwrapModuleDefault } from "./internal/interop";

export type GoogleAutocompleteProps = Omit<
	ReactGoogleAutocompleteInputProps & InputHTMLAttributes<HTMLInputElement>,
	"libraries" | "googleMapsScriptBaseUrl"
>;

const GoogleAutocompleteComponent = unwrapModuleDefault<
	ComponentType<GoogleAutocompleteProps & RefAttributes<HTMLInputElement>>
>(GoogleAutocompleteModule as unknown as ComponentType<GoogleAutocompleteProps & RefAttributes<HTMLInputElement>>);

const GoogleAutocomplete = forwardRef<HTMLInputElement, GoogleAutocompleteProps>((props, ref) => {
	return (
		<GoogleAutocompleteComponent
			{...props}
			ref={ref}
		/>
	);
});

GoogleAutocomplete.displayName = "GoogleAutocomplete";

export default GoogleAutocomplete;
